var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row items-center justify-start q-mb-md"},[_c('div',[_vm._v("Pay Monthly")]),_c('q-toggle',{attrs:{"false-value":_vm.BillingModel.MONTHLY,"true-value":_vm.BillingModel.ANNUALLY,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}}),_c('div',[_vm._v("Pay Annually")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }